import getTitle from 'helpers/getTitle'
import React from 'react'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault} from 'views/Shared'
import {renderReportReason} from './renderReportReason'
import {renderReportStatus} from './renderReportStatus'
import Translate from '../../../modules/local/Translate'

const defaultParams = {
  renderContextMenu: undefined,
}

const renderItem = (params) => (item) => {
  const { owner, status, creator, report_reason, description } = item ?? {}
  const { renderContextMenu = NullAsDefault } = params ?? {}
  return (
    <Translate>
      {(t) => (
        <div className="flex flex-col p-2 gap-3 border border-color-50 hover:border-color-base hover:shadow-items rounded-lg relative">
          <div className="absolute right-0 top-0 p-1">
            {renderContextMenu(item)}
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-xs text-color-300 italic">{`${t(
              'reason'
            )} : `}</span>
            <div className="flex items-center gap-2 px-3 py-1 background-100 rounded-md">
              <div className="flex-1">{renderReportReason(report_reason)}</div>
              {renderReportStatus(status)}
            </div>
          </div>
          <div className="flex flex-col">
            <span className="text-xs text-color-300 italic">{`${t(
              'title'
            )} : `}</span>
            <div className="flex flex-col px-2">
              <span className="font-semibold text-sm text-color-000">
                {getTitle(item)}
              </span>
              <span className="text-xs text-color-500 italic leading-tight">
                {description}
              </span>
            </div>
          </div>
        </div>
      )}
    </Translate>
  )
}

export const renderUserReportItem = renderItem

export const renderCodiReportItem = renderItem

const renderReportItem =
  (type, params = defaultParams) =>
  (item) => {
    switch (type) {
      case AppEntities.USER:
        return renderUserReportItem(params)(item)
      case AppEntities.CODI_DOCUMENT:
        return renderCodiReportItem(params)(item)
      default:
        break
    }
    return renderItem(params)(item)
  }

export default renderReportItem
